import React, { memo } from 'react';
export const ProblemSection = memo(function ProblemSection() {
  const problems = [{
    icon: '💸',
    text: 'Pagás fortunas por arreglos que podrías hacer vos mismo.'
  }, {
    icon: '⚡',
    text: 'Le tenés miedo a los cables y no sabés por dónde empezar.'
  }, {
    icon: '📉',
    text: 'Necesitás una salida laboral real y no encontrás el método.'
  }];
  return <section className="py-12 px-4 bg-gray-900" data-id="element-169">
      <div className="max-w-2xl mx-auto" data-id="element-170">
        <h2 className="text-[22px] md:text-3xl font-black text-white leading-tight text-center mb-8" data-id="element-171">
          ¿Te sentís identificado con{' '}
          <span className="text-blue-500" data-id="element-172">alguna de estas?</span>
        </h2>

        <div className="space-y-3 mb-8" data-id="element-173">
          {problems.map((p, i) => <div key={i} className="flex items-center gap-4 bg-gray-800 border border-gray-700 rounded-xl px-5 py-4" data-id="element-174">
              <span className="text-2xl flex-shrink-0" data-id="element-175">{p.icon}</span>
              <p className="text-white font-bold text-[14px] md:text-base leading-snug" data-id="element-176">
                {p.text}
              </p>
            </div>)}
        </div>

        <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl px-5 py-4 text-center" data-id="element-177">
          <p className="text-blue-400 font-bold text-[14px] md:text-base" data-id="element-178">
            El Megapack Eléctrico PRO fue creado exactamente para vos.
          </p>
        </div>
      </div>
    </section>;
});